import { ReadValuePlaceholder } from './ReadValuePlaceholder'

/**
 * Read-mode dla pola RICH_TEXT -- renderuje HTML z prose-classes. Brak wartości
 * (null/empty) fall back do ReadValuePlaceholder z "—".
 */
export function RichTextReadView({ value }: { value: unknown }) {
  if (!value) return <ReadValuePlaceholder display="—" />
  return (
    <div
      className="text-sm text-slate-900 [&_p]:my-1 [&_strong]:font-semibold [&_em]:italic [&_h2]:text-base [&_h2]:font-semibold [&_h3]:font-medium [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_blockquote]:border-l-2 [&_blockquote]:border-slate-300 [&_blockquote]:pl-3 [&_blockquote]:italic [&_a]:text-sky-700 [&_a]:underline"
      dangerouslySetInnerHTML={{ __html: String(value) }}
    />
  )
}
